/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：398
 */

"use strict"

export { s as b }
var r = {}
function o(e, t) {
  0
}
function i(e, t) {
  0
}
function a(e, t, n) {
  if (!(t || r[n])) {
    e(false, n)
    r[n] = true
  }
}
function s(e, t) {
  a(i, e, t)
}
var _a
_a = function (e, t) {
  a(o, e, t)
}
export { _a as a }
export default _a
